import {
  Box,
  BoxProps,
  Divider,
  Heading,
  Icon,
  TextInput,
} from '@hover/blueprint';
import { iSearch } from '@hover/icons';
import React, { FC } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { ArrowButton } from '@hover/shared-components';

interface Props extends BoxProps {
  handleSubmit: Function;
  showBlogLink: boolean;
}

const SearchBarDesktop: FC<Props> = ({
  handleSubmit,
  showBlogLink,
  ...rest
}) => (
  <Box
    justifyContent="space-between"
    direction="row"
    alignItems="center"
    display="flex"
    {...rest}
  >
    <Box alignItems="center">
      <Heading size={800} isLight marginBottom={0} mr="56px">
        Blog
      </Heading>
      {showBlogLink && (
        <ArrowButton
          as={GatsbyLink}
          to="/blog/"
          variant="minimal"
          sx={{
            // TODO(buttons): remove when we remove padding in Blueprint
            div: { pl: 0, pr: 50 },
          }}
        >
          All articles
        </ArrowButton>
      )}
    </Box>
    <Box dir="row" alignItems="center">
      <Box px={600}>
        <Divider
          orientation="vertical"
          color="neutral.300"
          height={400}
          opacity={1}
        />
      </Box>
      <Icon color="brandNavy.500" icon={iSearch} size="large" />
      <TextInput
        name="search"
        placeholder="SEARCH..."
        size="small"
        borderColor="transparent"
        onChange={e => {
          handleSubmit({ keyword: e.target.value });
        }}
        _placeholder={{
          color: 'brandNavy.300',
          fontSize: '12px',
          fontWeight: 700,
          lineHeight: '16px',
          letterSpacing: '0.05em',
        }}
      />
    </Box>
  </Box>
);

export default SearchBarDesktop;
